'use strict';

var ImmobiliareFlux = require('immobiliare-flux'),
  swig = require('swig');

module.exports = ImmobiliareFlux.createComponent({
  tpl: swig.compile(
    require('../views/form-error-helper-text.html.twig')
  )
});
